import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, Typography, Button, Box } from '@material-ui/core';
import richTextViewer from "../RichTextViewer.bs";
import colors from 'seagull/foundations/colors.module.scss';

const SvgX = () => /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.40994 7.00019L12.7099 2.71019C13.1021 2.31806 13.1021 1.68231 12.7099 1.29019C12.3178 0.898063 11.6821 0.898063 11.2899 1.29019L6.99994 5.59019L2.70994 1.29019L2.70994 1.29019C2.31782 0.898063 1.68206 0.898063 1.28994 1.29019C0.897817 1.68231 0.897817 2.31807 1.28994 2.71019L5.58994 7.00019L1.28994 11.2902C0.897817 11.6791 0.895221 12.3123 1.28414 12.7044C1.28607 12.7063 1.288 12.7083 1.28994 12.7102H1.28994C1.67886 13.1023 2.31202 13.1049 2.70414 12.716C2.70608 12.7141 2.70801 12.7121 2.70994 12.7102L6.99994 8.41018L11.2899 12.7102V12.7102C11.6789 13.1023 12.312 13.1049 12.7041 12.716C12.7061 12.7141 12.708 12.7121 12.7099 12.7102C13.1021 12.3213 13.1047 11.6881 12.7157 11.296C12.7138 11.294 12.7119 11.2921 12.7099 11.2902L8.40994 7.00019Z",
  fill: "#939393"
}));

const RichTextViewer = richTextViewer.make;
const useStyles = makeStyles(_theme => ({
  dialogHeader: {
    margin: '32px 40px 0px 40px',
    paddingBottom: '16px',
    borderBottom: "solid 1px ".concat(colors.dark100)
  },
  simpleHeader: {
    borderBottom: "solid 1px ".concat(colors.dark100),
    paddingBottom: '16px',
    marginBottom: '24px'
  },
  dialogContent: {
    position: 'relative',
    width: '720px',
    margin: '24px 40px 32px 40px'
  },
  btnx: {
    position: 'absolute',
    right: '16px',
    top: '32px',
    cursor: 'pointer',
    fontFamily: 'sans serif',
    fontSize: '18px',
    color: colors.dark200
  },
  modalTitle: {
    fontSize: '26px',
    fontWeight: 400,
    color: colors.dark900,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '24px'
  }
}));

function getDefaultText(text) {
  return typeof (text || '') === 'string' ? [{
    typ: 'p',
    children: [{
      text: text || ''
    }]
  }] : text;
}

export default function RichTextViewerModal(props) {
  const {
    show,
    title,
    text,
    onCancel
  } = props;
  const classes = useStyles();
  const defaultText = getDefaultText(text);
  const [richText, setRichText] = useState(defaultText);
  const sections = {
    header: /*#__PURE__*/React.createElement(Box, {
      className: classes.dialogHeader
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: classes.modalTitle
    }, title), /*#__PURE__*/React.createElement(Button, {
      className: classes.btnx,
      onClick: onCancel
    }, /*#__PURE__*/React.createElement(SvgX, null))),
    content: /*#__PURE__*/React.createElement(Box, {
      className: classes.dialogContent
    }, /*#__PURE__*/React.createElement(RichTextViewer, {
      automationId: "richtextviewer-modal",
      value: richText,
      disabled: false,
      onBlur: () => {},
      onChange: setRichText
    }))
  }; //

  return /*#__PURE__*/React.createElement(Dialog, {
    open: show,
    onClose: onCancel,
    scroll: "paper",
    maxWidth: 'xl'
  }, sections.header, sections.content);
}